const modalSelector = {
    modalLogin: (state) => state.modal.modalLogin,
    modalSignUp: (state) => state.modal.modalSignUp,
    modalLogout: (state) => state.modal.modalLogout,
    modalDelete: (state) => state.modal.modalDelete,
};
export default modalSelector;
